// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2dbwa","title":"styles_title__9pPFK"};
module.exports.__checksum = "d47ba8ef390b"